import 'jspdf-autotable'
import { jsPDF } from "jspdf"
import Loading from '@/components/widgets/Loading.vue'

export default {
  data() {
    return {
      loading: false,
      buyer: {
        name: 'SANGTHAI INDUSTRY CO., LTD.',
        address: '94/43 หมู่ 4 เศรษฐกิจ 1-บางปลา ต.บ้านเกาะ อ.เมือง จ.สมุทรสาคร',
        taxno: '12345678910',
        tel: '0-3483-0032-7, 0-3483-0289',
        fax: '0-3483-0028'
      },
      document: {
        no: 'ICPI-202216554654',
        date: '25/09/2019',
        condition: 'ชำระภายใน 7 วัน',
        credit: '30 วัน',
        duedate: '25/09/2022'
      },
      emp: {
        code: 'EMP-001',
        name: 'เกริกวิทย์',
        department: 'ฝ่ายผลิต',
        address: 'เลขที่ 72 ถ.แจ้งวัฒนะ ต.ตลาดบางเขน อ.หลักสี่ รหัสไปรษณีย์ 10210',
        taxno: '12345678999',
        tel: '0-3483-0032-7'
      },
      consignee: {
        code: 'EMP-002',
        name: 'กชมน',
        department_code: 'D-001',
        department: 'ฝ่ายผลิต',
        address: 'เลขที่ 72 ถ.แจ้งวัฒนะ ต.ตลาดบางเขน อ.หลักสี่ รหัสไปรษณีย์ 10210',
        taxno: '12345678999',
        tel: '0-3483-0032-7'
      },
      products: [
        {
          _id: '61837be876a431b5936932ba',
          code: 'P-001',
          name: 'สินค้า1',
          warehouse: 'คลัง1',
          storege: 'แถว1',
          unit: 'ลัง',
          disc: 250,
          price: 2500,
          qty: 2,
          total: 5000
        },
        {
          _id: '61837be876a431b5936932bb',
          code: 'P-002',
          name: 'สินค้า2',
          warehouse: 'คลัง1',
          storege: 'แถว1',
          unit: 'ลัง',
          disc: 0,
          price: 2500,
          qty: 2,
          total: 5000
        }
      ],
      note: 'เบิกสินค้า -> กรุณาโอนเงินเข้าบัญชี ธนาคารไทยพาณิชย์ ชื่อบัญชี สมกานดา ศุภชลาลัย เลขที่บัญชี xxxxxxxxxx สาขา พีทีที คริสตัล',
      discount: 150,
      nettotal: 0,
      afterDisc: 0
    }
  },
  components: {
    Loading
  }, 
  mounted() {
    this.$nextTick(() => {
      this.onInitData()
    })
  },
  methods: {
    async onInitIFrame() {
      this.loading = true
      setTimeout(async () => {
        const doc = new jsPDF('p','mm','a4')
        await this.onInitDocument(doc)
        let element = document.getElementById('requisition')
        if (element) {
          element.setAttribute("src", doc.output('bloburl'))
          setTimeout(() => {
            this.loading = false
            this.onIframePrint()
          }, 1500)
        }
      }, 1000)
    },
    onIframePrint() {
      let iFrame = document.getElementById("requisition")
      iFrame.focus()
      iFrame.contentWindow.print()
    },
    onInitDocument(doc) {
        return new Promise(async(resolve, reject) => {
        try {
          doc.addFileToVFS(
            'THSarabunNew.ttf',
            // ttf font file converted to base64
            // following is Consolas with only hex digit glyphs defined (0-9, A-F)
            this.thSarabunNormal
          )
          // add custom font to file
          doc.addFont('THSarabunNew.ttf', 'THSarabunNew', 'normal')
          doc.setFont('THSarabunNew', 'normal')

          doc.addFileToVFS(
            'THSarabunNew Bold.ttf',
            // ttf font file converted to base64
            // following is Consolas with only hex digit glyphs defined (0-9, A-F)
            this.thSarabunBold
          )
          // add custom font to file
          doc.addFont('THSarabunNew Bold.ttf', 'THSarabunNew', 'bold')
          doc.setFont('THSarabunNew', 'bold')

          const head = await this.onInitHeader()
          const body = await this.onInitBody(doc)
          doc.autoTable({
            theme: 'plain',
            margin: { top: 8, bottom: 0, left: 8, right: 8 },
            styles: {
              font: 'THSarabunNew'
            },
            headStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            bodyStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            footStyles: {
              valign: 'top',
              halign: 'center',
              minCellHeight: 0
            },
            showFoot: 'lastPage',
            head: head,
            body: body,
            willDrawCell (data) {
              if (data.cell.raw && data.section === 'head') {
                if (data.cell.raw.content === 'breaklineheader') {
                  const width = doc.internal.pageSize.getWidth() - 16
                  data.doc.setLineWidth(0.2)
                  data.doc.setDrawColor(100, 116, 139)
                  data.doc.line(data.cell.x, data.cell.y + 5, data.cell.x + width, data.cell.y + 5)
                }
              }
            }
          })
          const sub_footer = await this.onInitSubFooter(doc)
          doc.autoTable({
            theme: 'plain',
            margin: { top: 8, bottom: 8, left: 8, right: 8 },
            startY: doc.lastAutoTable.finalY,
            styles: {
              font: 'THSarabunNew'
            },
            headStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            bodyStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            footStyles: {
              valign: 'top',
              halign: 'center',
              minCellHeight: 0
            },
            showFoot: 'lastPage',
            foot: sub_footer
          })

          const footer = await this.onInitFooter(doc)
          doc.autoTable({
            theme: 'plain',
            margin: { top: 8, bottom: 8, left: 8, right: 8 },
            styles: {
              font: 'THSarabunNew'
            },
            headStyles: { },
            bodyStyles: {
              valign: 'top',
              minCellHeight: 0
            },
            footStyles: {
              valign: 'bottom',
              halign: 'center',
              minCellHeight: 0
            },
            showFoot: 'lastPage',
            foot: footer,
            willDrawCell (data) {
              if (data.cell.raw && data.section === 'foot') {
                if (data.cell.raw.content === 'storage') {
                    data.doc.setLineWidth(0.3)
                    data.doc.setDrawColor(15, 23, 42)
                    data.doc.line(data.cell.x + 4, data.cell.y + 18, data.cell.x + 45, data.cell.y + 18)
                  }
                if (data.cell.raw.content === 'issuer') {
                  data.doc.setLineWidth(0.3)
                  data.doc.setDrawColor(15, 23, 42)
                  data.doc.line(data.cell.x + 4, data.cell.y + 18, data.cell.x + 45, data.cell.y + 18)
                }
                if (data.cell.raw.content === 'approved') {
                  data.doc.setLineWidth(0.3)
                  data.doc.setDrawColor(15, 23, 42)
                  data.doc.line(data.cell.x + 4, data.cell.y + 18, data.cell.x + 45, data.cell.y + 18)
                }
                if (data.cell.raw.content === 'accepted' ) {
                  data.doc.setLineWidth(0.3)
                  data.doc.setDrawColor(15, 23, 42)
                  data.doc.line(data.cell.x + 4, data.cell.y + 18, data.cell.x + 45, data.cell.y + 18)
                }
              }
            }
          })
          resolve(doc)
        } catch (error) {
          reject(error)
        }
      })
    },
    onInitData() {
      for (let index = 0; index < this.products.length; index++) {
        const element = this.products[index]
        element.total = (element.qty * element.price) - element.disc
        this.nettotal += (element.qty * element.price) - element.disc
      }
      this.afterDisc = this.nettotal - this.discount
    },
    onInitHeader() {
      return new Promise(async (resolve, reject) => {
        const head = [
          [
            {
              content: 'ใบเบิกสินค้า',
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 26,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'bold',
                halign: 'left',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: 'Requisitions',
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 22,
                textColor: [15, 23, 42],
                cellPadding: {
                  bottom: 2
                },
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: this.buyer.name,
              colSpan: 5,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: 'เลขที่เอกสาร:',
              colSpan: 3,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: this.document.no,
              colSpan: 1,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: this.buyer.address,
              colSpan: 6,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: 'วันที่เอกสาร:',
              colSpan: 2,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: this.document.date,
              colSpan: 1,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: `เลขประจำตัวผู้เสียภาษี: ${this.buyer.taxno}`,
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: `ติดต่อ: ${this.buyer.tel}`,
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: `Fax: ${this.buyer.fax}`,
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: 'breaklineheader',
              colSpan: 9,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [255, 255, 255],
                cellPadding: 0,
                fontStyle: 'bold',
                halign: 'center',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: `ผู้บันทึก: ${this.emp.code} ${this.emp.name}`,
              colSpan: 5,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: {
                    top: 2
                },
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: `แผนก: ${this.consignee.department_code} ${this.consignee.department}`,
              colSpan: 4,
              styles: {
                lineWidth: 0,
                overflow: 'visible',
                cellWidth: 'wrap',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: 0,
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            }
          ],
          [
            {
              content: '',
              colSpan: 6,
              styles: {
                lineWidth: 0,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: {
                  bottom: 5
                },
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: `ผู้รับสินค้า: ${this.consignee.code} ${this.consignee.name }`,
              colSpan: 3,
              styles: {
                lineWidth: 0,
                overflow: 'visible',
                cellWidth: 'wrap',
                fontSize: 15,
                textColor: [15, 23, 42],
                cellPadding: {
                  bottom: 5
                },
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            }
          ],
          [
            {
              content: 'ลำดับ',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'center',
                valign: 'top'
              }
            },
            {
              content: 'รายการ',
              colSpan: 3,
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'center',
                valign: 'top'
              }
            },
            {
              content: 'คลัง/ที่เก็บ',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            },
            {
              content: 'จำนวน',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            },
            {
              content: 'ราคา/หน่วย',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            },
            {
              content: 'หน่วยนับ',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            },
            {
              content: 'จำนวนเงิน',
              styles: {
                lineWidth: 0.1,
                fillColor: [243, 244, 246],
                cellPadding: 2,
                cellWidth: 'auto',
                fontSize: 15,
                textColor: [15, 23, 42],
                fontStyle: 'normal',
                halign: 'right',
                valign: 'top'
              }
            }
          ]
        ]
        resolve(head)
      })
    },
    onInitBody(doc) {
      return new Promise(async (resolve, reject) => {
        const width = doc.internal.pageSize.getWidth() - 18
        const portion = width / 9
        const fraction = portion / 2
        const halfTwo = portion + fraction
        const data = this.products          
        const body = []
        for (let index = 0; index < data.length; index++) {
          const element = data[index]
          let obj = {}
          obj = [
            {
              content: index + 1,
              styles: {
                cellWidth: portion / 1.5,
                lineWidth: {
                  left: 0.1,
                  right: 0.1
                },
                fontSize: 15,
                fillColor: [255, 255, 255],
                textColor: [15, 23, 42],
                cellPadding: {
                  left: 2,
                  right: 2,
                  top: 1,
                  bottom: 1
                },
                fontStyle: 'normal',
                halign: 'center',
                valign: 'middle'
              }
            },
            {
              content: `${element.code} ${element.name}`,
              colSpan: 3,
              styles: {
                lineWidth: {
                  left: 0.1,
                  right: 0.1
                },
                cellWidth: 'auto',
                fontSize: 15,
                fillColor: [255, 255, 255],
                textColor: [15, 23, 42],
                cellPadding: {
                  left: 2,
                  right: 2,
                  top: 1,
                  bottom: 1
                },
                fontStyle: 'normal',
                halign: 'left',
                valign: 'middle'
              }
            },
            {
              content: `${element.warehouse}  ${element.storege}`,
              styles: {
                lineWidth: {
                  left: 0.1,
                  right: 0.1
                },
                cellWidth: portion + fraction,
                fontSize: 15,
                fillColor: [255, 255, 255],
                textColor: [15, 23, 42],
                cellPadding: {
                  left: 2,
                  right: 2,
                  top: 1,
                  bottom: 1
                },
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: this.$options.filters.numberFormat(element.qty),
              styles: {
                lineWidth: {
                  left: 0.1,
                  right: 0.1
                },
                cellWidth: portion,
                fontSize: 15,
                fillColor: [255, 255, 255],
                textColor: [15, 23, 42],
                cellPadding: {
                  left: 2,
                  right: 2,
                  top: 1,
                  bottom: 1
                },
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: this.$options.filters.numberFormat(element.price),
              styles: {
                lineWidth: {
                  left: 0.1,
                  right: 0.1
                },
                fontSize: 15,
                cellWidth: portion + (fraction / 2),
                fillColor: [255, 255, 255],
                textColor: [15, 23, 42],
                cellPadding: {
                  left: 2,
                  right: 2,
                  top: 1,
                  bottom: 1
                },
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: element.unit,
              styles: {
                lineWidth: {
                  left: 0.1,
                  right: 0.1
                },
                fontSize: 15,
                cellWidth: portion,
                fillColor: [255, 255, 255],
                textColor: [15, 23, 42],
                cellPadding: {
                  left: 2,
                  right: 2,
                  top: 1,
                  bottom: 1
                },
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            },
            {
              content: this.$options.filters.numberFormat(element.total),
              styles: {
                lineWidth: {
                  left: 0.1,
                  right: 0.1
                },
                fontSize: 15,
                cellWidth: halfTwo,
                fillColor: [255, 255, 255],
                textColor: [15, 23, 42],
                cellPadding: {
                  left: 2,
                  right: 2,
                  top: 1,
                  bottom: 1
                },
                fontStyle: 'normal',
                halign: 'right',
                valign: 'middle'
              }
            }
          ]
          body.push(obj)
        }

        let emptyBody = {}
        emptyBody = [
          {
            content: '',
            styles: {
              cellWidth: portion / 1.4,
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              fontSize: 15,
              fillColor: [255, 255, 255],
              textColor: [255, 255, 255],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              fontStyle: 'normal',
              halign: 'center',
              valign: 'middle'
            }
          },          
          {
            content: '',
            colSpan: 3,
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              fillColor: [255, 255, 255],
              textColor: [255, 255, 255],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              cellWidth: 'auto',
              fontSize: 15,
              fontStyle: 'normal',
              halign: 'left',
              valign: 'middle'
            }
          },
          {
            content: '',
            styles: {
              cellWidth: portion,
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              fontSize: 15,
              fillColor: [255, 255, 255],
              textColor: [255, 255, 255],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              fontStyle: 'normal',
              halign: 'center',
              valign: 'middle'
            }
          },
          {
            content: '',
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              cellWidth: portion,
              fontSize: 15,
              fillColor: [255, 255, 255],
              textColor: [255, 255, 255],
              fontStyle: 'normal',
              halign: 'right',
              valign: 'top'
            }
          },
          {
            content: '',
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              cellWidth: portion + 5,
              fontSize: 15,
              fillColor: [255, 255, 255],
              textColor: [255, 255, 255],
              fontStyle: 'normal',
              halign: 'right',
              valign: 'top'
            }
          },
          {
            content: '',
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              cellWidth: portion,
              fontSize: 1,
              fillColor: [255, 255, 255],
              textColor: [255, 255, 255],
              fontStyle: 'normal',
              halign: 'center',
              valign: 'top'
            }
          },
          {
            content: '',
            styles: {
              lineWidth: {
                left: 0.1,
                right: 0.1
              },
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              cellWidth: portion,
              fontSize: 1,
              fillColor: [255, 255, 255],
              textColor: [255, 255, 255],
              fontStyle: 'normal',
              halign: 'center',
              valign: 'top'
            }
          }
        ]

        if (body.length <= 10) {
          const number = 10 - body.length
          for (let index = 0; index < number; index++) {
            body.push(emptyBody)
          }
        }

        resolve(body)
      })
    },
    onInitFooter(doc) {
      return new Promise((resolve, reject) => {
        const width = doc.internal.pageSize.getWidth() - 20
        const content_width = parseInt(width/4)

        const footer = []
        const signer_line = [
          {
            content: `storage`,
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [255, 255, 255],
            cellPadding: {
                top: 15
            },
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          },
          {
            content: `issuer`,
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [255, 255, 255],
            cellPadding: 0,
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          },
          {
            content: `approved`,
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [255, 255, 255],
            cellPadding: 0,
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          },
          {
            content: `accepted`,
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [255, 255, 255],
            cellPadding: 0,
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          }
        ]
        footer.push(signer_line)

        const signer_style = {
          cellWidth: content_width,
          fontSize: 15,
          textColor: [15, 23, 42],
          cellPadding: 0,
          fontStyle: 'normal',
          halign: 'center',
          valign: 'bottom'
        }
        const signer_name = [
          {
            content: 'ผู้บันทึก',
            colSpan: 2,
            styles: signer_style
          },
          {
            content: 'ผู้รับของ',
            colSpan: 2,
            styles: signer_style
          },
          {
            content: 'ผู้ตรวจสอบ',
            colSpan: 2,
            styles: signer_style
          },
          {
            content: 'ผู้อนุมัติ',
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [15, 23, 42],
            cellPadding: 0,
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          }
        ]
        footer.push(signer_name)
        
          const signer_date = [
          {
            content: `( ${ this.$options.filters.getDateShortFormatted(new Date())} )`,
            colSpan: 2,
            styles: signer_style
          },
          {
            content: `( ${ this.$options.filters.getDateShortFormatted(new Date())} )`,
            colSpan: 2,
            styles: signer_style
          },
          {
            content: `( ${ this.$options.filters.getDateShortFormatted(new Date())} )`,
            colSpan: 2,
            styles: signer_style
          },
          {
            content: `( ${ this.$options.filters.getDateShortFormatted(new Date())} )`,
            colSpan: 2,
            styles: {
            cellWidth: 'auto',
            fontSize: 15,
            textColor: [15, 23, 42],
            cellPadding: 0,
            fontStyle: 'normal',
            halign: 'center',
            valign: 'bottom'
            }
          }
        ]
        footer.push(signer_date)
        resolve(footer)
      })
    },
    onInitSubFooter(doc) {
      return new Promise((resolve, reject) => {
        const width = doc.internal.pageSize.getWidth() - 18
        const portion = width / 9
        const fraction = portion / 2
        const halfTwo = portion + fraction
        
        const footer = []
        const total = [{
            content: `หมายเหตุ: ${this.note}`,
            colSpan: 5,
            styles: {
              lineWidth: 0.1,
              cellPadding: 2,
              cellWidth: 'auto',
              fontSize: 15,
              textColor: [15, 23, 42],
              fontStyle: 'normal',
              halign: 'left',
              valign: 'bottom'
            }
          },
          {
            content: 'รวมเงิน',
            styles: {
              lineWidth: 0.1,
              fillColor: [243, 244, 246],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              cellWidth: portion,
              fontSize: 15,
              textColor: [15, 23, 42],
              fontStyle: 'normal',
              halign: 'right',
              valign: 'bottom'
            }
          },
          {
            content: this.$options.filters.numberFormat(this.nettotal),
            colSpan: 2,
            styles: {
              lineWidth: 0.1,
              fillColor: [255, 255, 255],
              cellPadding: {
                left: 2,
                right: 2,
                top: 1,
                bottom: 1
              },
              cellWidth: halfTwo,
              fontSize: 15,
              textColor: [15, 23, 42],
              fontStyle: 'normal',
              halign: 'right',
              valign: 'bottom'
            }
          }
        ]
        footer.push(total)
        resolve(footer)
      })
    }
  }
}
